module.exports = __webpack_public_path__ + "img/magnifying-glass.25846f14.png";